"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppSelector = exports.useAppDispatch = exports.persistor = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const redux_persist_1 = require("redux-persist");
const session_1 = __importDefault(require("redux-persist/lib/storage/session"));
const autoMergeLevel2_1 = __importDefault(require("redux-persist/lib/stateReconciler/autoMergeLevel2"));
const react_redux_1 = require("react-redux");
const appSlice_1 = __importDefault(require("./slices/appSlice"));
const ehdSlice_1 = __importDefault(require("./slices/ehdSlice"));
const bookingSlice_1 = __importStar(require("./slices/bookingSlice"));
const ehd_1 = require("../helpers/ehd");
const persistConfig = {
    key: `prosang_3_${process.env.NODE_ENV}`,
    storage: session_1.default,
    // blacklist: ['pages'],
    stateReconciler: autoMergeLevel2_1.default,
};
const reducers = {
    app: appSlice_1.default,
    ehd: ehdSlice_1.default,
    booking: bookingSlice_1.default,
};
const combinedReducers = (0, toolkit_1.combineReducers)(reducers);
const persistedReducer = (0, redux_persist_1.persistReducer)(persistConfig, combinedReducers);
// Fix this any type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const rootReducer = (state, action) => {
    if (action.type === 'persist/PURGE') {
        state = Object.assign(Object.assign({}, state), { app: Object.assign(Object.assign({}, state.app), { user: null, sidebarOpen: false }), ehd: Object.assign({}, ehd_1.initialState), booking: Object.assign({}, bookingSlice_1.initialState) });
    }
    return persistedReducer(state, action);
};
const store = (0, toolkit_1.configureStore)({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false,
    }).concat(),
});
exports.persistor = (0, redux_persist_1.persistStore)(store);
exports.useAppDispatch = react_redux_1.useDispatch;
exports.useAppSelector = react_redux_1.useSelector;
exports.default = store;
